
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login/mitid",
      function () {
        return require("private-next-pages/login/mitid.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/login/mitid"])
      });
    }
  